<template>
    <td :colspan="cell.colspan" class="capacity__cell">
        <div v-if="cell.ad" class="capacity__ad capacity__ad-booked" v-tooltip="tooltip">
            <router-link :to="link">
                {{ cell.ad.order.company.name }} ({{ cell.ad.starts_at | date }} - {{ cell.ad.ends_at | date }})
            </router-link>
        </div>
    </td>
</template>

<script>
    export default {
        props: ['cell'],

        computed: {
            link() {
                return '/companies/' + this.cell.ad.order.company.id + '/orders/' + this.cell.ad.order.id + '/time-based-ads/' + this.cell.ad.id
            },

            tooltip() {
                return this.$options.filters.date(this.cell.ad.starts_at) + ' - ' + this.$options.filters.date(this.cell.ad.ends_at)
            }
        }
    }
</script>
